import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { CloudAlert, UploadCloud } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { api, ApiError } from '@/lib/axios'

async function postUploadArchive(data: FormData) {
  const response = await api.dashboard.post('/files', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

export function useUploadArchive() {
  const { t } = useTranslation('panel')

  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    FormData
  >({
    mutationFn: postUploadArchive,
    onSuccess: () => {
      toast(Toast, {
        data: {
          type: 'success',
          icon: UploadCloud,
          title: t('upload_files.toast_success_upload.title'),
        },
      })
    },
    onError: (error) => {
      toast(Toast, {
        data: {
          type: 'danger',
          icon: CloudAlert,
          title: t('upload_files.toast_error_upload.title'),
          description: error?.response?.data?.friendlyMessage,
        },
      })
    },
  })

  return {
    uploadArchive: mutateAsync,
    isUploadingArchive: isPending,
  }
}
